import { toggleLoader } from './shared';

import 'tw-elements';

function ready() {
  toggleLoader(false);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', ready);
} else {
  ready();
}
